import { animateCSS } from '@/utils/index'
export default {
  mounted(el, binding) {
    el.addEventListener('click', () => {
      if (el.getAttribute('disable-pulse') !== 'true') {
        // dom元素上可以设置disable-pulse来禁用效果
        animateCSS(el, 'pulse')
      }
    })
  },
}
